import { Fornecedor, RecuperarSenhaResponse } from "../../entities/fornecedores/fornecedor"
import api from "../../plugins/api"

export const login = async (username: string, password: string): Promise<Fornecedor> => {
    try {
        const { data } = await api.post<Fornecedor>(`/fornecedor/login`, { username, password })
        return data
    } catch (err: any) {
        if (err?.response?.data?.error) {
            throw new Error(err.response.data.error)
        }
        throw err
    }
}

export const recuperarSenha = async (username: string, email: string): Promise<void> => {
    try {
        await api.post<RecuperarSenhaResponse>(`/fornecedor/recuperar-senha`, { username, email })
        
    } catch (err: any) {
        if (err?.response?.data?.error) {
            throw new Error(err.response.data.error)
        }
        throw err
    }
}

export const alterarSenha = async (senha: string, token: string): Promise<void> => {
    try {
        await api.post<RecuperarSenhaResponse>(`/fornecedor/alterar-senha`, { senha, token })
    } catch (err: any) {
        if (err?.response?.data?.error) {
            throw new Error(err.response.data.error)
        }
        throw err
    }
}